module.exports = __webpack_public_path__ + "static/img/life-proposal3.db288182.png";